// extracted by mini-css-extract-plugin
export var buttonCustomClass = "NSDCModalContent-module--buttonCustomClass--dd239";
export var buttonCustomTextClass = "NSDCModalContent-module--buttonCustomTextClass--3085e";
export var certificateCousel = "NSDCModalContent-module--certificateCousel--0d3e9";
export var container = "NSDCModalContent-module--container--62595";
export var controlButtons = "NSDCModalContent-module--controlButtons--d2151";
export var left = "NSDCModalContent-module--left--e7ab4";
export var lmsScrollbar = "NSDCModalContent-module--lms-scrollbar--b0145";
export var right = "NSDCModalContent-module--right--7a328";
export var wrapper = "NSDCModalContent-module--wrapper--b21f7";